// extracted by mini-css-extract-plugin
module.exports = {"rightSideDrawer":"RightSideDrawer_rightSideDrawer__3-EIR","rightSideDrawerMobile":"RightSideDrawer_rightSideDrawerMobile__386s-","anchor":"RightSideDrawer_anchor__32HXj"};